import Modal from "../../common/Modal";
import { ChangeEvent, FormEvent, useState } from "react";
import { useSeller } from "../../../context/seller";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Group, Passenger } from "../../../types/common.types";
import GeneralInput from "../../common/GeneralInput";
import { TCountryCode } from "countries-list";
import CountryInput from "../../common/CountryInput";
import validate from "../../../utils/validateForm";
import { submitGroup } from "../../../schema/group";
import NacimientoYSexo, { DatosNacimiento, datosParaEnviar, faltaNacimiento } from "../NacimientoYSexo";
import { useGlobal } from "../../../context/global";
import SellerService from "../../../services/seller.service";

export default function CreateGroup() {
    const { setMessage, setIsLoading } = useGlobal()
    const { setNewGroup, setNewGroupReservationData, setIsCreateGroupModalOpen } = useSeller()

    const initialPassenger = {
        name: '',
        nationality: 'CL' as TCountryCode,
        email: '',
        phone: '',
        rut_passport: '',
        hotel: '',
        remark: ''
    } as Passenger
    const [ groupMembers, setGroupMembers ] = useState<Partial<Passenger>[]>([initialPassenger])
    // Fecha de nacimiento (o edad) y sexo de cada pasajero, en el mismo orden (16/10/2026).
    const [ nacimientos, setNacimientos ] = useState<DatosNacimiento[]>([{}])
    // El correo es opcional (16/10/2026): se agrega con un botón, pasajero por pasajero.
    const [ conCorreo, setConCorreo ] = useState<boolean[]>([])

    function setNacimiento(index: number, cambio: DatosNacimiento) {
        setNacimientos(prev => prev.map((n, i) => i === index ? { ...n, ...cambio } : n))
    }

    function onChangeNumberPassengers(e: ChangeEvent<HTMLInputElement>) {
        const value = e.target.value
        if (value === '') {
            setGroupMembers([])
            setNacimientos([])
            return
        }
        const number = parseInt(value)
        setNacimientos(prev => prev.length >= number ? prev.slice(0, number) : prev.concat(Array.from({ length: number - prev.length }, () => ({}))))
        if (number > groupMembers.length) {
            setGroupMembers((prevData) => {
                const newMembers = Array.from({length: number - prevData.length}, () => ({
                    ...initialPassenger,
                }))
            return prevData.concat(newMembers)
            })
        } else {
            setGroupMembers((prevData) => prevData.slice(0, number))
        }
    }

    function onChangeGroupMember(e: ChangeEvent<HTMLInputElement>, index: number) {
        const name = e.target.name
        let value: string | number = e.target.value
        if (e.target.type === 'number') value = Number(value)
            setGroupMembers((prevData) => {
                const newMembers = [...prevData]
                const oldMember = newMembers[index]
                newMembers[index] = {
                    ...oldMember,
                    [name]: value
                }
                return newMembers
            })
    }

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        const conFalta = nacimientos.findIndex(n => faltaNacimiento(n))
        if (conFalta >= 0) {
            setMessage({ type: 'error', content: `Pasajero ${conFalta + 1}: ${faltaNacimiento(nacimientos[conFalta])}` })
            setTimeout(() => setMessage(undefined), 5000)
            return
        }
        setIsLoading(true)
        try {
            const miembros = groupMembers.map(({ age, birth_date, sex, ...resto }, i) => ({ ...resto, ...datosParaEnviar(nacimientos[i] || {}) }))
            validate(submitGroup, miembros, true)
            let newGroupCorrectID: Partial<Passenger>[] = []
            for (let i = 0; i < miembros.length; i++) {
                const passsenger = miembros[i];
                const new_passenger_id = (await SellerService.createPassenger(passsenger)).data
                const new_passenger = {
                    ...passsenger,
                    ...new_passenger_id
                }
                newGroupCorrectID.push(new_passenger)
            }
            setNewGroup(newGroupCorrectID)
            const newGroup: Group = await (await SellerService.createGroup()).data
            setNewGroupReservationData(prevData => ({
                ...prevData,
                group_id: newGroup.id,
            }))
            setMessage({
                type: 'success',
                content: 'Passengers and group successfully created'
            })
        } catch (error) {
            console.log(error);
            
            setMessage({
                type: 'error',
                content: 'Error in data entered, make sure to fill all required fields'
            })
        } finally {
            setTimeout(() => {
                setMessage(undefined)
            }, 2500)
            setIsLoading(false)
        }
    }

    return (
        <Modal
        onSubmit={onSubmit}
        >
            <h1>Create new group</h1>
            <GeneralInput
            type="number"
            min={0}
            max={10}
            defaultValue={1}
            label="Number of passengers"
            onChange={onChangeNumberPassengers}
            />
            {
                groupMembers.map((member, index) => {
                    return (
                        <div style={{ margin: '10px 0'}} key={index} className="group-member">
                            <h2>Passenger {index + 1}</h2>
                            <div style={{display: 'flex',  gap: '10px', flexWrap: 'wrap'}}>
                                <GeneralInput
                                label="Name"
                                value={member.name || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="Carlos Perez"
                                name="name"
                                style={{marginBottom: '20px'}}
                                required
                                />
                                {
                                    conCorreo[index] ? (
                                        <GeneralInput
                                        label="Email"
                                        value={member.email || ''}
                                        onChange={e => onChangeGroupMember(e, index)}
                                        placeholder="example@example.com"
                                        name="email"
                                        type="email"
                                        style={{marginBottom: '20px'}}
                                        />
                                    ) : (
                                        <button type="button" onClick={() => setConCorreo(prev => { const n = [...prev]; n[index] = true; return n })} style={{border: "1px dashed #999", borderRadius: 8, background: "none", padding: "6px 12px", cursor: "pointer", marginBottom: 20}}>+ Agregar correo</button>
                                    )
                                }
                            </div>
                            <div style={{display: 'flex',  gap: '10px', flexWrap: 'wrap'}}>
                                <GeneralInput
                                label="Phone"
                                value={member.phone || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="+58 412-0713771"
                                name="phone"
                                style={{marginBottom: '20px'}}
                                required
                                />
                                <GeneralInput
                                label="Rut / Passport"
                                value={member.rut_passport || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="XXXXXXXX-Z"
                                name="rut_passport"
                                style={{marginBottom: '20px'}}
                                />
                            </div>
                            <div style={{display: 'flex',  gap: '10px', flexWrap: 'wrap'}}>
                                <GeneralInput
                                label="Hotel"
                                value={member.hotel || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="APANATOR"
                                name="hotel"
                                style={{marginBottom: '20px'}}
                                />
                            </div>
                            <NacimientoYSexo value={nacimientos[index] || {}} onChange={cambio => setNacimiento(index, cambio)} />
                            <div style={{display: 'flex',  gap: '10px', flexWrap: 'wrap'}}>
                                <GeneralInput
                                label="Remark"
                                value={member.remark || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="Vegetarian"
                                name="remark"
                                style={{marginBottom: '20px'}}
                                />
                                <CountryInput
                                label="Nationality"
                                buscable
                                name="nationality"
                                value={member.nationality}
                                onChange={(e) => onChangeGroupMember(e, index)}
                                style={{marginBottom: '20px'}}
                                />
                            </div>
                        </div>
                    )
                })
            }
            <div className="actions">
                <button type="submit">Continue</button>
            </div>
            <div className="close" title="close"
            onClick={() => setIsCreateGroupModalOpen(false)}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}